import { callApi } from './api.service';
import { ApiResponse } from '../models/api-response';

const API_URL = import.meta.env.VITE_API_SERVER_URL;

export interface UserProfile {
  id: string;
  email: string;
  tenant_id: string | null;
  first_name: string | null;
  last_name: string | null;
  company_name: string | null;
  phone_number: string | null;
  job_title: string | null;
  marketing_consent: boolean;
  onboarding_completed: boolean;
}

export interface UserProfileUpdate {
  first_name: string;
  last_name: string;
  company_name?: string;
  phone_number?: string;
  job_title: string;
  marketing_consent: boolean;
}

export interface ProductOnboardingState {
  intro_seen: boolean;
  dashboard_tour_done: boolean;
  job_details_tour_done: boolean;
}

/**
 * Get the current user's profile
 */
export const getUserProfile = async (token: string): Promise<ApiResponse<UserProfile>> => {
  return callApi<UserProfile>(`${API_URL}/api/users/me`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
};

/**
 * Update the current user's profile (used during onboarding)
 */
export const updateUserProfile = async (
  token: string,
  data: UserProfileUpdate
): Promise<ApiResponse<UserProfile>> => {
  return callApi<UserProfile>(`${API_URL}/api/users/me/profile`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
};

export const getProductOnboardingState = async (
  token: string
): Promise<ApiResponse<ProductOnboardingState>> => {
  return callApi<ProductOnboardingState>(`${API_URL}/api/users/me/product-onboarding`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateProductOnboardingState = async (
  token: string,
  data: Partial<ProductOnboardingState>
): Promise<ApiResponse<ProductOnboardingState>> => {
  return callApi<ProductOnboardingState>(`${API_URL}/api/users/me/product-onboarding`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
};
